import { service } from '@maia/cart';
import { queryOptions } from '@tanstack/react-query';

export function getCompositionQuestionsOptions(
  params: Parameters<typeof service.getCompositionQuestions>[number],
) {
  return queryOptions({
    queryFn: () => service.getCompositionQuestions(params),
    queryKey: [
      'getCompositionQuestions',
      params.cartGuid,
      params.productGuid,
      params.customerGuid,
    ],
  });
}
